// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"7bca1c5c","107":"448cfb78","242":"d6be0d0f","376":"8c5694b3","613":"01a8942f","785":"deacd578","982":"8358c39b"}[chunkId] + ".chunk.js";
};